module.exports = __webpack_public_path__ + "img/62.b63062d9.jpg";